export default __webpack_public_path__ + "static/media/ForceAnalysisImg.f4ce2420.jpg";